import { createFileRoute } from '@tanstack/react-router'
import { FabricStoragePage, isCapacityChip, isStorageTab, type FabricStorageParams } from '@bloo-team/product-fabric'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): the route
 * infrastructure — path, search-param validation — stays in the app's tree;
 * the surface lives in @bloo-team/product-fabric. `?tab=` picks the section
 * (capacity · retention · stores); `archives` — the tab's name before capture
 * A0 showed event stores are saved datasets — is an alias for `stores`, and
 * anything else falls back to capacity (docs/storage-requirements.md §The page).
 * `?chip=` (largest · no-retention · replicated) pre-filters the capacity tab —
 * Datafabric · Overview's storage checks land here; it is ignored on other tabs.
 */
function StorageRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const { tab, chip } = Route.useSearch()
  return <FabricStoragePage clusterId={clusterId} scopeId={scopeId} tab={tab} chip={chip} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/fabric/storage')({
  validateSearch: (search: Record<string, unknown>): FabricStorageParams => {
    const tab = search.tab === 'archives' ? 'stores' : isStorageTab(search.tab) ? search.tab : 'capacity'
    return { tab, chip: tab === 'capacity' && isCapacityChip(search.chip) ? search.chip : undefined }
  },
  component: StorageRoute,
})
